import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Area } from 'src/app/shared/models/area';

@Component({
	selector: 'app-area-ajout-form-modal',
	templateUrl: './area-ajout-form-modal.component.html',
	styleUrls: ['./area-ajout-form-modal.component.scss']
})
export class AreaAjoutFormModalComponent {
	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp(
		"^[0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+( [0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+)*$"
	);

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	formAjout = new FormGroup({
		name: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		description: new FormControl('', Validators.maxLength(255))
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = { value: false };

	area: Area = new Area();

	constructor(public bsModalRef: BsModalRef, private facade: FacadeService) {}

	// ngOnInit(): void {}

	onSubmit() {
		if (this.formAjout.valid) {
			this.isValidateButtonClicked.value = true;
			const userCenter =
				this.facade.dataStorageService.getUser()?.employee.serviceCenter;
			this.area.serviceCenter = userCenter;
			this.facade.areaService.postArea(this.area).subscribe({
				complete: () => {
					this.isValidateButtonClicked.value = false;
					this.bsModalRef.hide();
				},
				error: (err: ErrorResponse) => {
					this.isValidateButtonClicked.value = false;
					this.facade.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
				}
			});
		}
	}
}
